const actions = {
    SNACKBAR_SET: 'SNACKBAR_SET',
    SNACKBAR_RESET: 'SNACKBAR_RESET',
}

export default actions;
